import { Box, Stack } from '@mui/material';
import _ from 'lodash';
import { EmptyImg } from '../../../../layouts/dashboard/nav/IconButton';

export function FacilityImageInput({ fetch }: any) {
  return (
    <>
      {_.isEmpty(fetch) ? (
        <EmptySpace props={{ height: '150px', width: '100%' }} />
      ) : (
        <Box
          component="img"
          alt="시설물 사진"
          src={fetch}
          sx={{
            width: '100%',
            height: '150px',
          }}
        />
      )}
    </>
  );
}

export function MapListImageInput({ imgUrl }: any) {
  return (
    <>
      {_.isEmpty(imgUrl) ? (
        <EmptySpace
          props={{ height: '124px', width: '124px', borderRadius: '10px' }}
        />
      ) : (
        <Box
          component="img"
          alt="시설물 사진"
          src={imgUrl}
          sx={{
            width: '124px',
            height: '124px',
            borderRadius: '10px',
          }}
        />
      )}
    </>
  );
}

export function EmptySpace({ props }: any) {
  return (
    <Stack
      sx={{ background: '#f8f8f8', ...props }}
      justifyContent="center"
      alignItems="center"
    >
      <EmptyImg />
    </Stack>
  );
}
